"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var socket_io_service_1 = require("./socket-io.service");
/** Socket factory */
function SocketFactory(config) {
    return new socket_io_service_1.WrappedSocket(config);
}
exports.SocketFactory = SocketFactory;
exports.SOCKET_CONFIG_TOKEN = new core_1.InjectionToken('__SOCKET_IO_CONFIG__');
var SocketIoModule = /** @class */ (function () {
    function SocketIoModule() {
    }
    SocketIoModule.forRoot = function (config) {
        return {
            ngModule: SocketIoModule,
            providers: [
                { provide: exports.SOCKET_CONFIG_TOKEN, useValue: config },
                {
                    provide: socket_io_service_1.WrappedSocket,
                    useFactory: SocketFactory,
                    deps: [exports.SOCKET_CONFIG_TOKEN]
                }
            ]
        };
    };
    SocketIoModule.decorators = [
        { type: core_1.NgModule, args: [{},] },
    ];
    /** @nocollapse */
    SocketIoModule.ctorParameters = function () { return []; };
    return SocketIoModule;
}());
exports.SocketIoModule = SocketIoModule;
//# sourceMappingURL=socket-io.module.js.map